module.exports = __webpack_public_path__ + "static/media/ap1.2cdbc33f.jpg";